var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      on: {
        dragenter: function ($event) {
          return _vm.onDragStart()
        },
        dragleave: function ($event) {
          return _vm.onDragEnd()
        },
        drop: function ($event) {
          return _vm.onFileDrop($event)
        },
      },
    },
    [
      _vm._t("default"),
      _c("transition", { attrs: { name: "fast-fade" } }, [
        _vm.isDragging
          ? _c("div", { staticClass: "file-overlay" }, [
              _c(
                "div",
                [_c("w-fa", { attrs: { icon: "file-upload", size: "8x" } })],
                1
              ),
              _c("div", [_vm._v(_vm._s(_vm.$ct("drop-your-files-here")))]),
            ])
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }